export default function BriefHeroImage({ heroImage, embedded = false }) {
  if (!heroImage?.url) return null;

  return (
    <figure className={embedded ? 'm-0 bg-white' : 'mb-10'}>
      <img
        src={heroImage.url}
        alt={heroImage.alt || ''}
        className="w-full block h-auto"
        loading="eager"
      />
    </figure>
  );
}
